export default "__VITE_ASSET__DlDY3y1r__"